import React, { memo } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "@/hooks/useTranslation";
import { Save, X } from "lucide-react";

interface CertificationFormData {
  name: string;
  issuer: string;
  date: string;
  description: string;
  url: string;
}

interface CertificationFormProps {
  formData: CertificationFormData;
  onFormDataChange: (field: string, value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  editingId?: string;
}

export const CertificationForm = memo(({
  formData,
  onFormDataChange,
  onSave,
  onCancel,
  editingId
}: CertificationFormProps) => {
  const { t } = useTranslation('ui');
  
  return (
    <div className="space-y-4 p-4 border rounded-lg bg-muted/50">
      <Input
        placeholder={t('certification_form.name_placeholder')}
        value={formData.name}
        onChange={(e) => onFormDataChange('name', e.target.value)}
      />
      <Input
        placeholder={t('certification_form.issuer_placeholder')}
        value={formData.issuer}
        onChange={(e) => onFormDataChange('issuer', e.target.value)}
      />
      <Input
        type="month"
        placeholder={t('certification_form.date_placeholder')}
        value={formData.date}
        onChange={(e) => onFormDataChange('date', e.target.value)}
      />
      <Input
        placeholder={t('certification_form.url_placeholder')}
        value={formData.url}
        onChange={(e) => onFormDataChange('url', e.target.value)}
      />
      <Textarea
        placeholder={t('certification_form.description_placeholder')}
        value={formData.description}
        onChange={(e) => onFormDataChange('description', e.target.value)}
      />
      <div className="flex gap-2">
        <Button onClick={onSave} disabled={!formData.name}>
          <Save className="h-4 w-4 mr-2" />
          {t('certification_form.save')}
        </Button>
        <Button
          variant="outline"
          onClick={onCancel}
        >
          <X className="h-4 w-4 mr-2" />
          {t('certification_form.cancel')}
        </Button>
      </div>
    </div>
  );
});

CertificationForm.displayName = "CertificationForm";